import React from 'react';
import PropTypes from 'prop-types';
import AddressIdUtil from '../../../common/AddressIdUtil';
import Message from '../../message/Message';
import messages from './Messages.json';

const onClick = func => (event) => {
  event.preventDefault();
  func();
};

const reloadPage = () => {
  window.location.reload();
};

const AddressSearchMessages = (props) => {
  const {
    address, resetAddressSearch, isAddressSelected, hasError, isUnavailable, isUfbReady, isChange, isUfbAvailable
  } = props;
  let messageData = messages.success;
  if (hasError) {
    messageData = messages.error;
    return (<Message
      message={messageData.message}
      messageLinkData={messageData.messageLink}
      address={address}
      onLinkClick={onClick(isChange ? resetAddressSearch : reloadPage)}
      actionText={messageData.actionText}
    />);
  }

  if (!isAddressSelected) {
    return null;
  }
  if (isUnavailable) {
    messageData = messages.unavailable;
  }
  if (isUfbAvailable) {
    messageData = messages.ufbAvailable;
  }
  if (isUfbReady) {
    messageData = messages.ufbReady;
  }
  return (<Message
    message={messageData.message}
    messageLinkData={messageData.messageLink}
    address={address}
    onLinkClick={onClick(isChange ? resetAddressSearch : AddressIdUtil.changeAddress(resetAddressSearch))}
    actionText={messageData.actionText}
    iconClassName={messageData.iconClassName}
  />);
};

AddressSearchMessages.defaultProps = {
  isChange: true
};

AddressSearchMessages.propTypes = {
  address: PropTypes.string,
  isAddressSelected: PropTypes.bool,
  isUnavailable: PropTypes.bool,
  isUfbReady: PropTypes.bool,
  isUfbAvailable: PropTypes.bool,
  hasError: PropTypes.bool,
  resetAddressSearch: PropTypes.func,
  isChange: PropTypes.bool
};

export default AddressSearchMessages;



/** WEBPACK FOOTER **
 ** ./src/components/AddressSearch/AddressSearchMessages/AddressSearchMessages.js
 **/